export default __webpack_public_path__ + "static/media/office4.72e72e4f.jpg";